import type { VetCustomPlanType } from '@farmersdog/lead-browser-storage';

import { ProductLineType } from '../../graphql/types';

import type { FetchLeadQuery, PetInputForQuote } from '../../graphql/types';
import type { PetRecipes } from '../../types';
interface ConvertToPetInputsForQuoteArgs {
  pets: FetchLeadQuery['lead']['pets'];
  currentPetRecipeSelection: string[];
  currentPetName: string;
  availablePetRecipesMap: PetRecipes;
  vetCustomizedPlan: VetCustomPlanType;
}

export function convertToPetInputsForQuote({
  pets,
  currentPetRecipeSelection,
  currentPetName,
  availablePetRecipesMap,
  vetCustomizedPlan,
}: ConvertToPetInputsForQuoteArgs): Omit<
  PetInputForQuote,
  'requestedCalories'
>[] {
  return pets.map(pet => {
    const selection =
      pet.name === currentPetName
        ? currentPetRecipeSelection
        : getNonCurrentPetSelection({
            pet,
            availablePetRecipesMap,
            vetCustomizedPlan,
          });

    return {
      name: pet.name,
      selection: {
        diy: null,
        fresh: {
          productLine: ProductLineType.Fresh,
          options: { recipes: selection },
        },
      },
    };
  });
}

function getNonCurrentPetSelection({
  pet,
  availablePetRecipesMap,
  vetCustomizedPlan,
}: {
  pet: FetchLeadQuery['lead']['pets'][number];
  availablePetRecipesMap: PetRecipes;
  vetCustomizedPlan: VetCustomPlanType;
}) {
  const storedPetSelection = pet.selection?.fresh?.options.recipes;
  const recommendation = availablePetRecipesMap[pet.name]
    .filter(recipe => recipe.recommended)
    .map(recipe => recipe.name);

  if (storedPetSelection && storedPetSelection.length > 0) {
    return storedPetSelection;
  }
  if (recommendation && recommendation.length > 0) {
    return recommendation;
  }

  // if this non-current pet has not made a selection,
  // and if there is no recommended recipe (i.e. it is a non-vet-referred pet),
  // this pet will use the vet-referred pet's selection to fetch an initial quote
  return vetCustomizedPlan?.freshRecipeNames ?? [];
}
